import * as ko from "knockout";
import { BaseService } from "./_common/_baseService";
import { portalHttpService } from "./_common/httpService";
import { container_line } from "organized";

class FileContainerService extends BaseService {
  constructor() {
    super("FileContainers");
  }

  public getContainersCodes = (searchTerm: string = null): Promise<string[]> => {
    return portalHttpService.post<string[]>(
      `${this.baseApiUrl()}/GetContainersCodes`,
      ko.toJSON({
        searchTerm: searchTerm,
      }),
    );
  };

  public getContaierNumberOfLines = (containerNumber: string): Promise<number> => {
    return portalHttpService.get<number>(`${this.baseApiUrl()}/GetContainerNumberOfLines/${containerNumber}`);
  };

  public getContainerLines = async (payload: any): Promise<any> => {
    const data = await portalHttpService.post<any[]>(`${this.baseApiUrl()}/GetContainerLines`, ko.toJSON(payload));

    return data.map((item: any) => {
      return new container_line(item);
    });
  };

  public copyAttachmentsToFolder = (payload: any): Promise<any[]> => {
    return portalHttpService.post<any[]>(`${this.baseApiUrl()}/CopyAttachmentsToFolder`, ko.toJSON(payload));
  };
}

export const fileContainerService = new FileContainerService();
